import React from 'react';
import { SearchByNameResult } from 'pages/Search/models';
import {
  LiensList,
  ParkingViolationJudgments,
  TransitAdjudicationBureauJudgments,
  EnvironmentalControlBoardJudgments,
} from '..';
import DocumentsList from '../DocumentsList/DocumentsList';
import { Tabs, Badge } from 'antd';
import { ResultTypeName } from 'pages/Search/Search.types';

const { TabPane } = Tabs;

const SearchByNameResultTabs: React.FC<{
  nameResult: SearchByNameResult;
}> = (props: { nameResult: SearchByNameResult }) => {
  const { nameResult } = props;
  const resultType: ResultTypeName = 'nameResult';

  return (
    <Tabs type="card">
      {nameResult.liens && nameResult.liens.items && (
        <TabPane
          tab={
            <>
              Judgments/Liens&nbsp;
              <Badge showZero={true} count={nameResult.liens.items.length} />
            </>
          }
          key="liens"
        >
          <LiensList
            searchId={nameResult.searchId}
            liens={nameResult.liens}
            groupName={nameResult.header}
            compName={'liens'}
            resultType={resultType}
            resultItemIndex={nameResult.index}
          />
        </TabPane>
      )}

      {nameResult.federalTaxLiens && nameResult.federalTaxLiens.items && (
        <TabPane
          tab={
            <>
              FTL's&nbsp;
              <Badge
                showZero={true}
                count={nameResult.federalTaxLiens.items.length}
              />
            </>
          }
          key="federalTaxLiens"
        >
          <DocumentsList
            documents={nameResult.federalTaxLiens}
            groupName={nameResult.header}
            compName="federalTaxLiens"
            resultType={resultType}
            resultItemIndex={nameResult.index}
          />
        </TabPane>
      )}

      {nameResult.parkingViolationJudgments &&
        nameResult.parkingViolationJudgments.items && (
          <TabPane
            tab={
              <>
                PVB's&nbsp;
                <Badge
                  showZero={true}
                  count={nameResult.parkingViolationJudgments.items.length}
                />
              </>
            }
            key="parkingViolationJudgments"
          >
            <ParkingViolationJudgments
              judgments={nameResult.parkingViolationJudgments}
              groupName={nameResult.header}
              resultType={resultType}
              resultItemIndex={nameResult.index}
            />
          </TabPane>
        )}

      {nameResult.environmentalControlBoardJudgments &&
        nameResult.environmentalControlBoardJudgments.items && (
          <TabPane
            tab={
              <>
                ECB's&nbsp;
                <Badge
                  showZero={true}
                  count={
                    nameResult.environmentalControlBoardJudgments.items.length
                  }
                />
              </>
            }
            key="environmentalControlBoardJudgments"
          >
            <EnvironmentalControlBoardJudgments
              judgments={nameResult.environmentalControlBoardJudgments}
              groupName={nameResult.header}
              resultType={resultType}
              resultItemIndex={nameResult.index}
            />
          </TabPane>
        )}

      {nameResult.transitAdjudicationBureauJudgments &&
        nameResult.transitAdjudicationBureauJudgments.items && (
          <TabPane
            tab={
              <>
                TAB's&nbsp;
                <Badge
                  showZero={true}
                  count={
                    nameResult.transitAdjudicationBureauJudgments.items.length
                  }
                />
              </>
            }
            key="transitAdjudicationBureauJudgments"
          >
            <TransitAdjudicationBureauJudgments
              judgments={nameResult.transitAdjudicationBureauJudgments}
              groupName={nameResult.header}
              resultType={resultType}
              resultItemIndex={nameResult.index}
            />
          </TabPane>
        )}

      {nameResult.uniformCommercialCodes &&
        nameResult.uniformCommercialCodes.items && (
          <TabPane
            tab={
              <>
                UCC's&nbsp;
                <Badge
                  showZero={true}
                  count={nameResult.uniformCommercialCodes.items.length}
                />
              </>
            }
            key="uniformCommercialCodes"
          >
            <DocumentsList
              documents={nameResult.uniformCommercialCodes}
              groupName={nameResult.header}
              compName="uniformCommercialCodes"
              resultType={resultType}
              resultItemIndex={nameResult.index}
            />
          </TabPane>
        )}

      {nameResult.recordedDocuments && nameResult.recordedDocuments.items && (
        <TabPane
          tab={
            <>
              Recorded Documents&nbsp;
              <Badge
                showZero={true}
                count={nameResult.recordedDocuments.items.length}
              />
            </>
          }
          key="recordedDocuments"
        >
          <DocumentsList
            documents={nameResult.recordedDocuments}
            groupName={nameResult.header}
            compName="recordedDocuments"
            resultType={resultType}
            resultItemIndex={nameResult.index}
          />
        </TabPane>
      )}
    </Tabs>
  );
};

export default React.memo(SearchByNameResultTabs);
